// ICONS
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

export const quickMenu = [
  {
    page_Name: "About Us",
    page_Link: "/",
  },
  {
    page_Name: "Menu",
    page_Link: "/",
  },
  {
    page_Name: "Careers",
    page_Link: "/",
  },
  {
    page_Name: "Contact Us",
    page_Link: "/",
  },
];

export const getInTouch = [
  {
    contact_Type: "Gmail",
    contact_Info: "info@alfayomicoffee.com",
    contact_Icon: faEnvelope,
  },
  {
    contact_Type: "Phone",
    contact_Info: "16521",
    contact_Icon: faPhone,
  },
  {
    contact_Type: "Info",
    contact_Info: "EL Mahalla , Gharbia ,Egypt",
    contact_Icon: faLocationDot,
  },
];

export const workingHours = [
  {
    working_Hours_Info: "10:00 AM - 2:00 AM",
  },
  {
    working_Hours_Info: "Thu & Fri: 10:00 AM - 3:00 AM",
  },
];
